import React from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';

export const DebouncedTextInput = ({
  onChange,
  debounce = 500,
  value: initialValue,
  ...props
}: {
  value: string | number;
  debounce?: number;
  onChange: (value: string | number) => void;
} & Omit<TextFieldProps, 'onChange'>) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <TextField {...props} value={value} onChange={(e) => setValue(e.target.value)} />
  );
};

export default DebouncedTextInput;
